import { UTSLocale } from "@smile2impress/attraction-constants";

import common from "./common";

export default (locale: UTSLocale) => {
    switch (locale) {
        default:
            return common;
    }
};
